import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

export default function LoaderComponent() {
  return (
    <div className='position-absolute bg-primary-container m-2 shadow rounded p-2' style={{ zIndex: 19999 }}><FontAwesomeIcon className='me-2' icon={faSpinner} spin />Loading </div>
  )
}
